import { cookiesAllowed } from '../../util/cookie_consent'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

export function whenAllowedToTrack (app, analyticsTracker) {
  return new Promise((resolve) => {
    if (trackingAllowed(app)) {
      resolve()
      return
    }

    const enableTrackingIfOnHold = function () {
      if (trackingAllowed(app)) {
        analyticsTracker.off('change:userId', enableTrackingIfOnHold)
        app.off('allow_cookies', enableTrackingIfOnHold)

        resolve()
      }
    }

    analyticsTracker.on('change:userId', enableTrackingIfOnHold)
    app.on('allow_cookies', enableTrackingIfOnHold)
  })
}

export function trackingAllowed (app) {
  const { options } = store.getState()[appSlice.name]

  if (options.allowAnalyticsTracking === 'consent') {
    return cookiesAllowed(app.state)
  } else {
    return options.allowAnalyticsTracking
  }
}
